// src/translate/native-tag-handlers/index-browser.ts
var eventNameReg = /^on[A-Z]/;
var changeNameReg = /Change$/;
var bindsByTag = {};
registerBind("input", "value");
registerBind("input", "checked");
registerBind("textarea", "value");
var index_browser_default = (attrs, def, tag, meta) => {
  const binds = bindsByTag[tag];
  const resultAttrs = {};
  for (const key in attrs) {
    const val = attrs[key];
    if (eventNameReg.test(key)) {
      if (val) {
        const eventName = key.toLowerCase();
        meta[eventName] = def.d(eventName.slice(2), val, false);
      }
    } else if (!((binds == null ? void 0 : binds[key]) || changeNameReg.test(key))) {
      resultAttrs[key] = val;
    }
  }
  if (binds) {
    for (const key in binds) {
      const handler = attrs[`${key}Change`];
      resultAttrs[key] = attrs[key];
      if (handler) {
        meta.oninput = def.d("input", binds[key](handler), false);
      } else {
        (meta.pa || (meta.pa = {}))[key] = 1;
      }
    }
  }
  return resultAttrs;
};
function registerBind(tag, prop) {
  bindsByTag[tag] = bindsByTag[tag] || {};
  bindsByTag[tag][prop] = (change) => (e) => change(e.target[prop]);
}
export {
  index_browser_default as default
};
